





















import { Vue, Component } from "vue-property-decorator";
import FullScreenLoading from "@/components/FullScreenLoading.vue";
import AlertError from "@/components/AlertError.vue";
import AlertSuccess from "@/components/AlertSuccess.vue";
import UserTable from "@/components/admin-users/UserTable.vue";
import AddUserPopup from "@/components/admin-users/AddUserPopup.vue";

import User, { UserInfo, NewUserInfo } from "@/controller/user";

@Component({
  components: {
    FullScreenLoading,
    AlertError,
    AlertSuccess,
    UserTable,
    AddUserPopup
  }
})
export default class AdminUsers extends Vue {
  users: UserInfo[] = [];
  loading = true;
  showAddUserPopup = false;
  isError = false;
  isAddingSuccessful = false;

  get displayUsers(): UserInfo[] {
    return this.getUsersExcludingCurrentUser();
  }

  private getUsersExcludingCurrentUser(): UserInfo[] {
    const currentUserEmail = this.$store.state.user.email;
    return this.users.filter(user => user.email !== currentUserEmail);
  }

  async created() {
    this.users = await User.getUsers();
    this.loading = false;
  }

  async deleteUser(email: string) {
    this.loading = true;

    try {
      const deleteSuccessful = await User.deleteUser(email);
      if (!deleteSuccessful) throw new Error("deleting user fails");
      this.removeLocalUsersByEmail(email);
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
    }
  }

  private removeLocalUsersByEmail(email: string) {
    const index = this.users.findIndex(user => user.email === email);

    if (index > -1) {
      this.users.splice(index, 1);
    }
  }

  async addUser(user: NewUserInfo) {
    this.loading = true;

    try {
      const addSuccessful = await User.createUser(user);
      if (!addSuccessful) throw new Error("adding user fails");
      const newUser: UserInfo = {
        displayName: user.displayName,
        email: user.email,
        role: user.role
      };
      this.users.push(newUser);
      this.toastSuccessMessage();
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
      this.showAddUserPopup = false;
    }
  }

  private toastSuccessMessage() {
    this.isAddingSuccessful = true;

    setTimeout(() => {
      this.isAddingSuccessful = false;
    }, 2000);
  }

  async editUser(email: string, role: string) {
    this.loading = true;

    try {
      const isSuccessful = await User.setUserRole(email, role);
      if (!isSuccessful) throw new Error("set role fails");
      this.updateEditedUserLocally(email, role);
    } catch (error) {
      this.isError = true;
    } finally {
      this.loading = false;
    }
  }

  private updateEditedUserLocally(email: string, role: string) {
    for (let i = 0; i < this.users.length; i++) {
      const user = this.users[i];
      if (user.email === email) {
        this.users[i].role = role;
        return;
      }
    }
  }
}
